import { has } from 'ramda';
import React, { useContext, useMemo } from 'react';
import { TableLayoutContext } from '../../layout-context';
import { BodyCell } from '../body-cell';
import { StyledBodyRow, StyledTooltip } from './styled';
function toCellItems(selectedRowIds, props) {
    return (cell) => {
        const { key, ...cellProps } = cell.getCellProps();
        return (React.createElement(BodyCell, { key: key, selectedRowIds: selectedRowIds, cell: cell, ...cellProps, additionalProps: props }));
    };
}
export const TableBodyRow = ({ onRowClick, row, selectedRowIds, style, props }) => {
    const layoutType = useContext(TableLayoutContext);
    const tooltipRef = React.useRef(null);
    const className = `invent-table-row ${row.index % 2 ? 'odd' : 'even'}`;
    const isDisabledRow = (row) => {
        var _a, _b, _c;
        if (has('isAuthorized', row.original) && !row.original.isAuthorized) {
            return !((_a = row.original) === null || _a === void 0 ? void 0 : _a.isAuthorized);
        }
        if (has('isDeleted', row.original) && ((_b = row.original) === null || _b === void 0 ? void 0 : _b.isDeleted)) {
            return (_c = row.original) === null || _c === void 0 ? void 0 : _c.isDeleted;
        }
        return false;
    };
    const tooltipContent = useMemo(() => {
        if (has('isAuthorized', row.original) && !row.original.isAuthorized) {
            return 'You have limited access to this record';
        }
        if (has('isDeleted', row.original) && row.original.isDeleted) {
            return 'You cannot view the record details because it was marked as deleted';
        }
        return null;
    }, [row]);
    return isDisabledRow(row) ? (React.createElement(StyledTooltip, { ref: tooltipRef, content: tooltipContent, disabled: false },
        React.createElement(StyledBodyRow, { as: layoutType === 'block' ? 'div' : undefined, className: className, "$isDisabled": true, ...row.getRowProps({
                style,
                onClick: undefined
            }) }, row.cells.map(toCellItems(selectedRowIds, props))))) : (React.createElement(StyledBodyRow, { as: layoutType === 'block' ? 'div' : undefined, className: className, "$isDisabled": false, ...row.getRowProps({
            style,
            onClick: onRowClick ? onRowClick(row) : undefined
        }) }, row.cells.map(toCellItems(selectedRowIds, props))));
};
